export default __webpack_public_path__ + "static/media/vehicle.0e9203f06ffb6a3b94679d835aa854cb.svg";